import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

import { dataUserSession } from "../../../utilities/dataSession";
//SERVICE
import { pContractorRequestStatusList } from "../../../service/100/P120Service";

//PAGE
import P120List from "./P120List";

export default function P120() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [requestSrh, setRequestSrh] = useState({
        requestNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    //Data
    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        if (dataUserSession()) {
            if (!history.location.state) {
                // setRequestSrh({ requestNo: "R651600360", userId: dataUserSession().userId });
                history.push("/100");
            } else {
                setRequestSrh({ ...requestSrh, ...history.location.state });
            }
        } else {
            history.push("/login");
        }
    }, []);
    useEffect(() => {
        if (requestSrh.requestNo !== "") onGetContractorContractInfo();
    }, [requestSrh]);

    const onGetContractorContractInfo = () => {
        setLoading(true);
        pContractorRequestStatusList(requestSrh).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValForm = (_key) => {
        if (dataTable.length > 0) return dataTable[0][_key];
    };
    const handlerGoBack = () => {
        history.push("/100");
    };
    return (
        <div>
            <Loading loading={loading} />
            <Toast ref={toast}></Toast>
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">ใบแจ้งฯเลขที่</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setValForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="100" value={setValForm("requestType")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" disabled={true} maxLength="20" value={setValForm("contractNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" disabled={true} maxLength="100" value={setValForm("routeName")} />
                            </div>
                        </div>
                        <br />
                        <P120List dataTable={dataTable} goBack={handlerGoBack} />
                    </div>
                </div>
            </div>
        </div>
    );
}
